import { getCurrencyCorrelations } from "@/_core/data/api_calls/correlations/getCurrencyCorrelations";
import { getCommodityCorrelations } from "@/_core/data/api_calls/correlations/getCommodityCorrelations";

export function getCorrelations(ctx, asset, assetExtraParams = {}) {
  ctx.showLoading = true;
  if (asset === "currency") {
    return getCurrencyCorrelations(ctx);
  } else if (asset === "commodity") {
    return getCommodityCorrelations(ctx, assetExtraParams);
  }
}
